import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=704dc9d6&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"
import style0 from "./MatchList.vue?vue&type=style&index=0&id=704dc9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704dc9d6",
  null
  
)

export default component.exports